import { FI18NPageImage, FPageBlock, FPageImagesLayout } from '../../mdl/f-page-block';
import { sUploadImage } from '../../mdl/s-upload';
import { UIInputAdapter } from '../../ui/component/adapter';
import { UILabeled } from '../../ui/component/labeled';
import { UIList } from '../../ui/component/list';
import { UISelect } from '../../ui/component/select';
import { UICheckbox } from '../../ui/component/toggle';
import { isImageMime, UIContent, UIDropDelegate, uiInitDropTarget } from '../../ui/dnd';
import { $el } from '../../ui/elements';
import { uiSetPrefixedClass } from '../../ui/functions';
import { UIValue } from '../../ui/types';
import { $log } from '../../y/debug';
import { $on } from '../../y/events';
import { $form } from '../../y/form';
import { EDBlock, EDBlockSpec } from '../block';
import { EDBlockContainer } from '../editor';
import { EDImageObject, EDSymbolInput } from '../image';
import { EDI18NInput } from '../input';

const image_layout_values: UIValue<FPageImagesLayout>[] = [{ key: 'row', name: 'Row' }, { key: 'flow', name: 'Flow' }, { key: 'big', name: 'Big' }];

export const ed_page_banner_block: EDBlockSpec<FPageBlock> = {
    key: 'banner',
    editor_block: class extends EDBlock implements UIDropDelegate {
        private _images: UIInputAdapter<FI18NPageImage, EDImageObject>;

        constructor(container: EDBlockContainer) {
            const sym = $el.DIV('sym');
            const symbol = new EDSymbolInput(sym);
            const multiply = new UICheckbox({ title: 'Multiply' });
            const text = new EDI18NInput({ multiline: false, placeholder: 'Button', classes: 'p-f-new-bubble' });

            const removeImage = (image: EDImageObject) => {
                const entry = images.findView(image);
                if(entry)
                    images.remove(entry);
            };

            const images = new UIInputAdapter<FI18NPageImage, EDImageObject>(() => {
                const image: EDImageObject = new EDImageObject(this, 'page', block, true, 'tl-image', removeImage);
                return { view: image, input: image };
            })

            const block = new UIList(images, { classes: 'ed-blk-banner w-block b b-content' });

            super($form({ images, symbol, text, multiply }), container, 'Banner', $el.DIV('l-form', [
                new UILabeled(symbol, { above: 'symbol' }),
                multiply,
            ]), block.ui_elem);

            this._images = images;
            if(!this.editor.translate_mode)
                uiInitDropTarget(this);

            $on(multiply, 'value', v => {
                this.classList.toggle('m-multiply', !!v);
            });

            this.ui_add($el.DIV('r-bubble', [sym, $el.DIV('o-bubble m-shadow m-top-arrow', text)]));
        }

        dropEnter(content: UIContent) {
            return content.type == 'files';
        }

        drop(content: UIContent) {
            if(content.type == 'files') {
                const valid_files = (content.value as File[]).filter((f: File) => isImageMime(f.type));
                if(valid_files.length)
                    this._onFiles(valid_files);
            }
        }

        private _onFiles(files: File[]) {
            Promise.allSettled(files.map(f => sUploadImage(f, 'page', {}))).then(results => {
                for(const r of results) {
                    if(r.status == 'fulfilled') {
                        const i = r.value;
                        this._images.push({ all: { image: i.id, height: Math.round(i.info.height / 2), width: Math.round(i.info.width / 2), aspect: i.info.width / i.info.height } })
                    } else {
                        $log('editor', 'failed', r.reason);
                    }
                }
            });
        }

        get children() {
            return this._images.views;
        }
    }
};

export const ed_page_images_block: EDBlockSpec<FPageBlock> = {
    key: 'images',
    editor_block: class extends EDBlock implements UIDropDelegate {
        private _images: UIInputAdapter<FI18NPageImage, EDImageObject>;

        constructor(container: EDBlockContainer) {
            const layout = new UISelect(image_layout_values, { kind: 'k-subtle' });
            const narrow = new UICheckbox({ title: 'Narrow' });
            const multiply = new UICheckbox({ title: 'Multiply' });
            const mobile_scale = new UICheckbox({ title: 'Scale down in mobile' });

            const removeImage = (image: EDImageObject) => {
                const entry = images.findView(image);
                if(entry)
                    images.remove(entry);
            };

            const images = new UIInputAdapter<FI18NPageImage, EDImageObject>(() => {
                const image: EDImageObject = new EDImageObject(this, 'page', list, false, 'tl-image', removeImage);
                return { view: image, input: image };
            })

            const list = new UIList(images, { classes: 'blk-images w-block b b-content' });

            super($form({ images, layout, narrow, multiply, mobile_scale }), container, 'Images', $el.DIV('l-form', [
                new UILabeled(layout, { above: 'Layout' }),
                narrow,
                multiply,
                mobile_scale
            ]), list.ui_elem);

            this._images = images;
            uiInitDropTarget(this);

            $on(layout, 'value', v => {
                uiSetPrefixedClass(list, 'k', v);
            });

            $on(narrow, 'value', v => {
                list.classList.toggle('w-block-1200', !!v);
                list.classList.toggle('w-block', !v);
            });
            $on(multiply, 'value', v => {
                list.classList.toggle('m-multiply', !!v);
            });
        }

        dropEnter(content: UIContent) {
            return content.type == 'files';
        }

        drop(content: UIContent) {
            if(content.type == 'files') {
                const valid_files = (content.value as File[]).filter((f: File) => isImageMime(f.type));
                if(valid_files.length)
                    this._onFiles(valid_files);
            }
        }

        private _onFiles(files: File[]) {
            Promise.allSettled(files.map(f => sUploadImage(f, 'page', {}))).then(results => {
                for(const r of results) {
                    if(r.status == 'fulfilled') {
                        const i = r.value;
                        this._images.push({ all: { image: i.id, height: Math.round(i.info.height / 2), width: Math.round(i.info.width / 2), aspect: i.info.width / i.info.height } })
                    } else {
                        $log('editor', 'failed', r.reason);
                    }
                }
            });
        }

        get children() {
            return this._images.views;
        }
    }
};
